import {
  ValidatorFn, AbstractControl, ValidationErrors, Validators
} from '@angular/forms';

export class ConditionalValidator {
  static validateWhen(key: string, ...validators: ValidatorFn[]): ValidatorFn {
    const composed = Validators.compose(validators);

    return (c: AbstractControl): ValidationErrors | null => {
      const other = c.root.get(key);

      if (other?.valid && other.value) {
        return composed(c);
      }
      return null;
    };
  }

  static validateWhenNot(key: string, ...validators: ValidatorFn[]): ValidatorFn {
    const composed = Validators.compose(validators);

    return (c: AbstractControl): ValidationErrors | null => {
      const other = c.root.get(key);

      if (other?.valid && !other.value) {
        return composed(c);
      }
      return null;
    };
  }

  static validateWhenEqual(key: string, value: any, ...validators: ValidatorFn[]): ValidatorFn {
    const composed = Validators.compose(validators);

    return (c: AbstractControl): ValidationErrors | null => {
      const other = c.root.get(key);

      if (other?.valid && other.value === value) {
        return composed(c);
      }
      return null;
    };
  }
}
